// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__KAFx9","left":"Hero_left__cugQL","right":"Hero_right__ekoqi","text":"Hero_text__D2kuO","ButtonGroup":"Hero_ButtonGroup__yd-Mu"};